import React from "react";
import styled from "styled-components";
import { Helmet } from "App/Atomics/Helmet";
import { Progress } from "utils/progress";
import { useLoadGoodsDetail } from "./Hooks/useLoadGoodsDetail";
import { useParams } from "lib/use-router";
import { TopbarTemplate } from "App/Templates/TopbarTemplate";
import { AppStore } from "App/Store-v3";
import { SidebarActions } from "App/Store-v3/Sidebar";
import { GoodsDetailForm } from "./GoodsDetailForm";
import { useScrollToTop } from "../GoodsCreate/Hooks/useScrollToTop";
import { useUpdateGoods } from "./Hooks/useUpdateGoods";
import { LeftSideBar } from "App/Molecules/LeftSidebar";
import { Input } from "App/Atomics/Input";
import { useHistory } from "lib/use-router";
import { useLoadGoodsTypes } from "./Hooks/useLoadGoodsTypes";

export const GoodsDetail = () => {
  const { id } = useParams<{ id: string }>();
  const { updateGoods, loading } = useUpdateGoods();
  const navigate = useHistory();
  const openSidebar = () => AppStore.dispatch(SidebarActions.open());
  useLoadGoodsTypes();
  useLoadGoodsDetail({ id: id! });
  useScrollToTop();

  const goBack = () => {
    if (window.confirm("이전 페이지로 돌아가시겠습니까?")) {
      navigate.goBack();
    }
  };

  return (
    <Layout>
      <Helmet title="굿즈 상세 정보" />
      <Progress.Bottom />
      <LeftSideBar />
      <TopbarTemplate openSidebar={openSidebar}>
        <ButtonGroup>
          <UpdateButton>
            <Input.Button disabled={loading} color="danger" onClick={goBack}>
              돌아가기
            </Input.Button>
          </UpdateButton>
          <UpdateButton>
            <Input.Button disabled={loading} color={"primary"} onClick={updateGoods}>
              저장하기
            </Input.Button>
          </UpdateButton>
        </ButtonGroup>
      </TopbarTemplate>
      <GoodsDetailForm />
    </Layout>
  );
};

const Layout = styled.div`
  display: flex;
  width: 100%;
  font-size: 0.9rem;
`;
const ButtonGroup = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;
const UpdateButton = styled.div`
  & + & {
    margin-left: 8px;
  }
`;
